module.exports = __webpack_public_path__ + "img/PEC8000_R.81b25a9d.png";